/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PaymentLinkType {
  MAIN_PAYMENT = 'main_payment',
  ADDITIONAL_PAYMENT = 'additional_payment',
}
